/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ServiceStatusEnum {
    NEW_ACCOUNT = 'NewAccount',
    NEW1UP = 'New1Up',
    SERVICE_ADDRESS = 'ServiceAddress',
    PENDING_CONNECT = 'PendingConnect',
    CONNECT = 'Connect',
    REGULAR = 'Regular',
    FINAL_PENDING = 'FinalPending',
    NEW_VACATION = 'NewVacation',
    OLD_VACATION = 'OldVacation',
    NEW_FINAL = 'NewFinal',
    NEW_TRANSFER = 'NewTransfer',
    OLD_FINAL = 'OldFinal',
    OLD_TRANSFER = 'OldTransfer',
    INACTIVE = 'Inactive',
}